import './StepIndicator.scss';

export { default } from './StepIndicator';
